import { createContext } from "react";

import { internationalization } from "../configs";

export const localeI18nContext = createContext(internationalization.en);
